import { useEffect, useState } from "react";
import MyButton from "../../UI/button/MyButton";
import { backend_routes } from "../../../common/links";
import { useAxiosGetRefreshing } from "../../../hooks/useAxios";
import EventModal from "../../event/EventModal";
import LegendsModal from "../../event/LegendsModal";
import MyModal from "../../UI/modal/MyModal";

const EventsUI = function ({ setEventsCallback, legendSetCallback, setIsEventsLoadingCallback, legendsMap, eventPostCallback}) {
    let nowDate = new Date();
    const getYYYYmmdd = function (date, shiftDays) {
        var dateOffset = (24 * 60 * 60 * 1000) * shiftDays;
        var myDate = new Date();
        myDate.setTime(date.getTime() + dateOffset);
        return myDate.getFullYear()
            + "-" + (myDate.getMonth() + 1).toString().padStart(2, 0)
            + "-" + myDate.getDate().toString().padStart(2, 0)
            + "T" + myDate.getHours().toString().padStart(2, 0)
            + ":" + myDate.getMinutes().toString().padStart(2, 0);
    }
    const [startDate, setStartDate] = useState(getYYYYmmdd(nowDate, -14));
    const [endDate, setEndDate] = useState(getYYYYmmdd(nowDate, 0));
    const changeStartDate = function (event) { setStartDate(event.target.value); }
    const changeEndDate = function (event) { setEndDate(event.target.value); }

    const offset = function(){
        let date = new Date();
        let offset = date.getTimezoneOffset();
        let absOffset = Math.abs(offset)
        let offHours = parseInt((absOffset)/60);
        let offMinutes = absOffset-(60*offHours);
        if (Math.abs(offHours)<10) offHours = "0"+offHours;
        if (Math.abs(offMinutes)<10) offMinutes = "0"+offMinutes;
        let outString = offHours+":"+offMinutes;

        if (offset<0) outString = ":00+"+outString;
        else outString = ":00-"+outString;
        return outString;
    }

    const [request, setRequest] = useState("");
    useEffect(() => {
        setRequest("?start=" + startDate + ":00.000Z&finish=" + endDate + ":00.000Z");
    }
        , [startDate, endDate]);

    const [fetchEvents, isEventsLoading] = useAxiosGetRefreshing(
        function (response) {
            setEventsCallback(response.data.data.events);
        }
    );

    useEffect(() => {
        setIsEventsLoadingCallback(isEventsLoading)
    }
        , [isEventsLoading]);
    const askEvents = function () {
        fetchEvents(backend_routes.EVENTS_LIST + request)
    }

    const [eventsModal, setEventsModal] = useState(false);
    const [legendsModal, setLegendsModal] = useState(false);

    const inputsStyle =
    {
        marginRight: "5px",
        fontSize: "16px",
        fontWeight: "bold",
        paddingLeft: "10px",
        height: "30px"
    } 
    return (
        <>
            <input style={inputsStyle} type="datetime-local" value={startDate} onChange={(event) => changeStartDate(event)} />
            <input style={inputsStyle} type="datetime-local" value={endDate} onChange={(event) => changeEndDate(event)} />
            <MyButton style={inputsStyle} onClick={askEvents}>Запрос событий</MyButton>
            <MyButton style={inputsStyle} onClick={() => setEventsModal(true)}>Создать событие</MyButton>
            <MyButton style={inputsStyle} onClick={() => setLegendsModal(true)}>Редактировать легенды</MyButton>
            <MyModal
                visible={eventsModal}
                setVisible={setEventsModal}
                // style={{ width: "50%" }}
            >
                <EventModal
                    event={{
                        Id: 0,
                        code: 0,
                        start: startDate + offset(),
                        finish: endDate + offset()
                    }}
                    legendsMap={legendsMap}
                    actionMethod={"POST"}
                    eventChangingCallback={eventPostCallback}
                    closeModalCallback={setEventsModal} />
            </MyModal>
            <MyModal
                visible={legendsModal}
                setVisible={setLegendsModal}
            >
                <LegendsModal
                    style={{ width: "40%" }}
                    legendsMap={legendsMap}
                    legendSetCallback={legendSetCallback}
                    closeModalCallback={setLegendsModal} 
                />
            </MyModal>
        </>
    );
}
export default EventsUI;